/*
 * Copyright (c) Worldline 2023.
 */

export const Steps = {
    'evidences': 1,
    'agreements': 2,
    'signatures': 3,
    'resume': 4
}
